import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';
import { IHttpGetWebDocByHash } from '../../../action/http.action';

export const getWebDocByHash = (templateId: string, hash: string) => returnAction<IHttpGetWebDocByHash>(ActionEnum.GET_WEB_DOC_BY_HASH, {
  templateId, hash
});
